import { JwMonitor } from "@4tn/webx-analytics";
import { isIosChrome } from "@utils/common/device";

export default function getMute() {
  if (!isIosChrome()) return false;
  // For iOS Chrome, we should always use muted autostart
  return JwMonitor.playReason === "autostart";
}
